import type { LucideIcon } from 'lucide-react'

/* The one icon container used across the whole technology section.
 *
 * It exists because the borders had already drifted — /18 on the hub, /20 on
 * the sub-pages, and a couple of white-bordered chips mixed in — which reads at
 * a glance as two different design systems bolted together. A brand-tinted
 * border is the section's rule; a white one is what a card gets, never an icon.
 *
 * Sizes are a closed set rather than a className passthrough on purpose: the
 * moment callers can pass their own border, the drift starts again.
 */

const SIZES = {
  sm: { box: 'h-9 w-9 rounded-lg', icon: 'h-4 w-4' },
  md: { box: 'h-11 w-11 rounded-xl', icon: 'h-5 w-5' },
} as const

export default function IconChip({
  icon: Icon,
  size = 'sm',
}: {
  icon: LucideIcon
  size?: keyof typeof SIZES
}) {
  const dimensions = SIZES[size]
  return (
    <span
      className={`flex shrink-0 items-center justify-center border border-[#ff6a1a]/25 bg-[#ff6a1a]/[0.07] ${dimensions.box}`}
      aria-hidden="true"
    >
      <Icon className={`${dimensions.icon} text-[#ff8c4d]`} />
    </span>
  )
}
